import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';
import api from '../services/api';

const WelcomeModal = ({ currentPlayer, onClose }) => {
  const { t } = useLocalization();

  const handleConfirm = async () => {
    if (currentPlayer?.id) {
      try {
        await api.put(`/api/players/${currentPlayer.id}/welcome-status`, {
          welcome_shown: true
        });
      } catch (error) {
        console.error('Failed to update welcome status:', error);
      }
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" style={{ fontFamily: 'Thicccboi, sans-serif' }}>
          {t('welcome.title')}
        </h2>
        
        <div className="space-y-4 text-gray-600">
          <div className="flex items-start space-x-3">
            <span className="text-xl">📚</span>
            <p>{t('welcome.modules')}</p>
          </div>
          
          <div className="flex items-start space-x-3">
            <span className="text-xl">🔓</span>
            <p>{t('welcome.themeUnlocking')}</p>
          </div>
          
          <div className="flex items-start space-x-3">
            <span className="text-xl">🥚</span>
            <p>{t('welcome.dragonProgress')}</p>
          </div>
          
          <div className="flex items-start space-x-3">
            <span className="text-xl">🐉</span>
            <p>{t('welcome.dragonLair')}</p>
          </div>
          
          <div className="flex items-start space-x-3">
            <span className="text-xl">⭐</span>
            <p>{t('welcome.stars')}</p>
          </div>
          
          <div className="flex items-start space-x-3">
            <span className="text-xl">👤</span>
            <p>{t('welcome.profile')}</p>
          </div>
        </div>
        
        <button
          onClick={handleConfirm}
          className="w-full mt-8 bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
          style={{ fontFamily: 'Thicccboi, sans-serif' }}
        >
          {t('welcome.gotIt')}
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;